// 贝叶斯AI性格测试系统 - API模块
class APIClient {
    constructor() {
        this.ossToken = null;
    }
    
    // 处理URL协议，确保与当前页面协议一致
    normalizeUrl(url) {
        if (!url) return url;
        
        // 如果URL以http://或https://开头，根据当前页面协议决定使用的协议
        if (url.startsWith('http://') || url.startsWith('https://')) {
            // 移除协议部分，使用协议相对URL
            const urlWithoutProtocol = url.replace(/^https?:/, '');
            
            // 如果当前页面是HTTPS，强制使用HTTPS
            if (window.location.protocol === 'https:') {
                return `https:${urlWithoutProtocol}`;
            }
            // 否则使用协议相对URL，让浏览器自动匹配
            return urlWithoutProtocol;
        }
        
        return url;
    }
    
    // 通用请求函数
    async myFetch(url, body) {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            return await response.json();
        } catch (error) {
            throw error;
        }
    }

    // 获取OSS Token
    async getOSSToken() {
        if (this.ossToken) {
            return this.ossToken;
        }
        
        try {
            const res = await this.myFetch('/api/osstoken', {});
            return res;
        } catch (error) {
            throw error;
        }
    }

    // 上传图片到OSS
    async uploadImageToOSS(blob, filename) {
        const ossToken = await this.getOSSToken();
        const formData = new FormData();
        
        // 规范化OSS host URL，确保协议兼容
        const normalizedHost = this.normalizeUrl(ossToken.host);
        
        formData.append('key', filename);
        formData.append('policy', ossToken.policy);
        formData.append('OSSAccessKeyId', ossToken.accessId);
        formData.append('success_action_status', '200');
        formData.append('signature', ossToken.signature);
        formData.append('file', blob, filename);

        try {
            const response = await fetch(normalizedHost, {
                method: 'POST',
                body: formData,
            });

            if (response.ok || response.status === 204) {
                // 返回规范化的URL
                return `${ossToken.host}/${filename}`;
            } else {
                throw new Error('上传失败');
            }
        } catch (error) {
            throw error;
        }
    }

    // 捕获并上传图片
    async captureAndUpload(video) {
        if (!video || video.videoWidth === 0) {
            throw new Error('视频流无效');
        }

        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        return new Promise((resolve, reject) => {
            canvas.toBlob(async (blob) => {
                if (!blob) {
                    reject(new Error('图片捕获失败'));
                    return;
                }

                try {
                    const filename = `capture_${Date.now()}.jpg`;
                    const url = await this.uploadImageToOSS(blob, filename);
                    resolve(url);
                } catch (error) {
                    reject(error);
                }
            }, 'image/jpeg', 0.8);
        });
    }
}

// 导出API客户端
const api = new APIClient();
export default api; 